import { IconCode } from './Code';
import { IconCalendar } from './Calendar';
import { IconClock } from './Clock';
import { IconChecklist } from './Checklist';
import { IconDocument } from './Document';
import { IconDocumentEdit } from './DocumentEdit';
import { IconGrid } from './Grid';
import { IconEye } from './Eye';
import { IconMail } from './Mail';
import { IconMailbox } from './Mailbox';
import { IconUserArrow } from './UserArrow';
import { IconLayers } from './Layers';
import { IconLock } from './Lock';
import { IconPhone } from './Phone';
import { IconPiggy } from './Piggy';
import { IconMoney } from './Money';
import { IconSign } from './Sign';
import { IconInfo } from './Info';
import { IconSearch } from './Search';
import { IconSettings } from './Settings';
import { IconSignal } from './Signal';
import { IconMode } from './Mode';
import { IconUser } from './User';
import { IconLogout } from './Logout';
import { IconWallet } from './Wallet';
import { IconHome } from './Home';
import { IconArrows } from './Arrows';
import { IconAsterisk } from './Asterisk';
import { IconSandbox } from './Sandbox';
import { IconDownload } from './Download';
import { IconHandCoins } from './HandCoins';
export const IconAnimation = {
    AnimationCode: IconCode,
    AnimationCalendar: IconCalendar,
    AnimationClock: IconClock,
    AnimationChecklist: IconChecklist,
    AnimationDocument: IconDocument,
    AnimationDocumentEdit: IconDocumentEdit,
    AnimationGrid: IconGrid,
    AnimationEye: IconEye,
    AnimationMail: IconMail,
    AnimationMailbox: IconMailbox,
    AnimationUserArrow: IconUserArrow,
    AnimationLayers: IconLayers,
    AnimationLock: IconLock,
    AnimationPhone: IconPhone,
    AnimationPiggy: IconPiggy,
    AnimationMoney: IconMoney,
    AnimationSign: IconSign,
    AnimationInfo: IconInfo,
    AnimationSearch: IconSearch,
    AnimationSettings: IconSettings,
    AnimationSignal: IconSignal,
    AnimationMode: IconMode,
    AnimationUser: IconUser,
    AnimationLogout: IconLogout,
    AnimationWallet: IconWallet,
    AnimationHome: IconHome,
    AnimationArrows: IconArrows,
    AnimationAsterisk: IconAsterisk,
    AnimationSandbox: IconSandbox,
    AnimationDownload: IconDownload,
    AnimationHandCoins: IconHandCoins,
};
//# sourceMappingURL=index.js.map